class Search {
    constructor(el) {
        this.scope = el;
        this.input = el.querySelector('input[name="searchTerm"]');
        this.page = el.querySelector('input[name="page"]');
        this.dropdown = el.querySelector("[data-dropdown]")
        this.criteriaElement = el.querySelector("[data-criteria]");
        this.criteriaLabel = el.querySelector("[data-criteria-label]");
        this.filters = document.querySelector('[data-filters]');
        this.hasOverlay = this.input.closest("[data-search-overlay]");
        this.searchUrl = el.action;
        this.value = "";
        this.pageValue = "";
        this.open = false;
        this.resizeFunction = debounce(() => this.search(), 500);
        this.bindTab = (e) => {
            if (!e.target.closest("[data-search]")) {
                this.closeDropDown();
                document.removeEventListener("keyup", this.bindTab);
            }
        };
        this.bindClick = (e) => {
            if (!e.target.closest("[data-search]")) {
                this.closeDropDown();
                document.removeEventListener("keyup", this.bindClick);
            }
        };
        this.bindEvents();
    }

    bindEvents() {
        this.input.addEventListener("input", () => this.updateCriteria());
        this.input.addEventListener("clear", () => this.updateCriteria());
        this.input.addEventListener("focus", () => this.value.length > 3 && this.openDropDown());

        if (this.filters) {
            this.filters.querySelectorAll('input').forEach(radio => {
                radio.addEventListener('input', e => {
                    const value = radio.value;
                    e.preventDefault();
                    this.value = this.input.value;
                    window.location.href = this.searchUrl + `?searchTerm=${this.value}&page=1&category=${value}`;
                });
            });
        }

        this.scope.addEventListener("submit", e => {
            e.preventDefault();
            this.value = this.input.value;
            window.location.href = this.searchUrl + `?searchTerm=${this.value}&page=1`;
        })

        const pagination = document.querySelector('.pagination');
        if (pagination) {
            const select = pagination.querySelector('select');
            if (select) {
                const dataEl = document.querySelector('[data-max]');
                if (dataEl) {
                    const maxPages = parseInt(dataEl.dataset.max);
                    const currentPage = parseInt(dataEl.dataset.currentPage);
                    const pageSize = parseInt(dataEl.dataset.pageSize);
                    const category = dataEl.dataset.category;

                    let options = [];
                    for (let i = 1; i <= maxPages; i++) {
                        options.push(`<option value=${i} ${currentPage === i ? "selected" : ""}>${i}</option>`)
                    }
                    select.innerHTML = options.join('');

                    const prev = pagination.querySelector('.button[title="Previous Page"]');
                    if (prev) {
                        if (currentPage === 1) {
                            prev.setAttribute('disabled', '');
                            prev.classList.add('disabled');
                        } else {
                            prev.removeAttribute('disabled');
                            prev.classList.remove('disabled');
                            prev.addEventListener("click", e => {
                                const newPage = currentPage - 1;
                                e.preventDefault();
                                this.value = this.input.value;
                                select.value = newPage.toString();
                                window.location.href = this.searchUrl + `?searchTerm=${this.value}&page=${newPage}&category=${category}`;
                            });
                        }
                    }

                    const next = pagination.querySelector('.button[title="Next Page"]');
                    if (next) {
                        if (currentPage === maxPages) {
                            next.setAttribute('disabled', '');
                            next.classList.add('disabled');
                        } else {
                            next.removeAttribute('disabled');
                            next.classList.remove('disabled');
                            next.addEventListener("click", e => {
                                const newPage = currentPage + 1;
                                e.preventDefault();
                                this.value = this.input.value;
                                select.value = newPage.toString();
                                window.location.href = this.searchUrl + `?searchTerm=${this.value}&page=${newPage}&category=${category}`;
                            });
                        }
                    }

                    select.addEventListener('change', e => {
                        e.preventDefault();
                        this.value = this.input.value;
                        window.location.href = this.searchUrl + `?searchTerm=${this.value}&page=${select.value}&category=${category}`;
                    });

                    const selectedCategory = document.querySelector('input[data-category-count]:checked');
                    if (selectedCategory) {
                        const count = parseInt(selectedCategory.dataset.categoryCount);
                        if (count <= pageSize) {
                            pagination.classList.add('pagination--hidden');
                        } else {
                            pagination.classList.remove('pagination--hidden');
                        }
                    }
                }
            }
        }
    }

    updateCriteria() {
        this.value = this.sanitise(this.input.value);
        this.pageValue = this.page ? this.page.value : "1";
        if (this.criteriaElement) {
            this.criteriaLabel.dataset.criteriaLabel = this.value;
            this.criteriaElement.href = this.searchUrl + `?searchTerm=${this.value}&page=${this.pageValue}`;
        }
        if (this.value.length > 2) {
            !this.open && this.openDropDown();
            this.resizeFunction();
        } else {
            this.open && this.closeDropDown();
        }
    }

    sanitise(value) {
        const map = {
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#x27;',
            "/": '&#x2F;',
        };
        const reg = /[&<>"'/]/ig;
        return value.replace(reg, (match) => (map[match]));
    }

    openDropDown() {
        this.dropdown.classList.add("form-group__dropdown--open");
        this.dropdown.parentElement.classList.add("form-group--dropdown-open");
        this.open = true;
        document.addEventListener("keyup", this.bindTab);
        document.addEventListener("click", this.bindClick);

    }

    closeDropDown() {
        this.dropdown.classList.remove("form-group__dropdown--open");
        this.dropdown.parentElement.classList.remove("form-group--dropdown-open");

        this.open = false;
    }

    search() {
        const search = new CustomEvent("search", {
            detail: {
                searchTerm: this.value
            },
        });
        this.scope.dispatchEvent(search);
    }
}

ControlBinders.register(`[data-search]`, el => new Search(el));